import { addCompletedCover, addCover, addValidatedCover } from '../../slices/selectCover';
import { AppDispatch } from '../../store';
import { Cover } from '../../types/cover';
import { Risk } from '../../types/policy';
import { Occupation } from '../../types/refData';
import { RiskClassCode } from '../../types/risk';
import { RiskNotFoundError } from './errors';
import { getCovers } from './getCovers';
import { getRiskByClassCode } from './getRiskByClassCode';
import { updateBreakdownCoverAction } from './updateBreakdownCoverAction';
import { updateBuildingAndContentsAction } from './updateBuildingAndContentsAction';
import { updateBusinessInterruptionCoverAction } from './updateBusinessInterruptionCoverAction';
import { updateInterestedPartiesAction } from './updateInterestedPartiesAction';
import { updateLiabilityAction } from './updateLiabilityAction';
import { updateMoneyDetailsCoverAction } from './updateMoneyDetailsCoverAction';
import { updatePortableItemsCoverAction } from './updatePortableItemsCoverAction';
import { updateTaxAuditCoverAction } from './updateTaxAuditCoverAction';
import { updateTheftCoverAction } from './updateTheftCoverAction';

export const updateCoversAction = ({
  risks,
  occupation,
  dispatch,
}: {
  risks: Risk[];
  occupation: Occupation | undefined;
  dispatch: AppDispatch;
}) => {
  const covers =
    getCovers({
      risks,
      dispatch,
    }) ?? [];

  const liabilityRisk = getRiskByClassCode(risks, RiskClassCode.Liability);
  if (!liabilityRisk) {
    throw new RiskNotFoundError(RiskClassCode.Liability);
  }

  /** @note bootstrap select cover slice */
  covers.forEach((cover) => {
    dispatch(addCover(cover));
    dispatch(addValidatedCover(cover));
    dispatch(addCompletedCover(cover));
  });
  if (covers.includes(Cover.Liability)) {
    updateLiabilityAction({
      liabilityRisk,
      occupation,
      dispatch,
    });
  }

  const buildingAndContentsRisk = getRiskByClassCode(risks, RiskClassCode.BuildingAndContents);

  if (covers.includes(Cover.BuildingAndContents)) {
    updateBuildingAndContentsAction({
      buildingAndContentsRisk,
      dispatch,
    });
  }

  if (covers.includes(Cover.BusinessInterruption)) {
    updateBusinessInterruptionCoverAction({
      buildingAndContentsRisk: getRiskByClassCode(risks, RiskClassCode.BuildingAndContents),
      dispatch,
    });
  }

  const portableItemsRisk = getRiskByClassCode(risks, RiskClassCode.PortableItems);
  if (covers.includes(Cover.PortableItems)) {
    updatePortableItemsCoverAction({
      portableItemsRisk,
      dispatch,
    });
  }
  const theftMoneyGlassRisk = getRiskByClassCode(risks, RiskClassCode.TheftMoneyGlass);
  if (covers.includes(Cover.Theft)) {
    updateTheftCoverAction({
      risk: theftMoneyGlassRisk,
      dispatch,
    });
  }
  if (covers.includes(Cover.Money)) {
    updateMoneyDetailsCoverAction({
      risk: getRiskByClassCode(risks, RiskClassCode.TheftMoneyGlass),
      dispatch,
    });
  }
  if (covers.includes(Cover.TaxAudit)) {
    updateTaxAuditCoverAction({
      risk: getRiskByClassCode(risks, RiskClassCode.TaxAudit),
      dispatch,
    });
  }

  updateBreakdownCoverAction({
    risks,
    dispatch,
  });

  updateInterestedPartiesAction({
    covers,
    buildingAndContentsRisk,
    portableItemsRisk,
    theftMoneyGlassRisk,
    dispatch,
  });
};
